import { createStore } from 'redux';
import claimReducer from '../reducers/claim_reducer.js';

const store = createStore(claimReducer);

export default store;
